module.exports = __webpack_public_path__ + "media/images/user/jan_01234567-4b44dc3d8e402ea7b0ed9de6fdcb2704.png";